import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { FiDownload, FiCopy, FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const QRCodeGenerator = ({ username, size = 200 }) => {
  const [copied, setCopied] = useState(false);
  const profileUrl = `${window.location.origin}/#/u/${username}`;

  const handleDownload = (format = 'png') => {
    const svg = document.getElementById('qr-code-svg');
    if (!svg) return;

    if (format === 'svg') {
      // Download as SVG
      const svgData = new XMLSerializer().serializeToString(svg);
      const blob = new Blob([svgData], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `hubid-${username}-qr.svg`;
      link.click();
      URL.revokeObjectURL(url);
    } else {
      // Download as PNG
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        canvas.width = size;
        canvas.height = size;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `hubid-${username}-qr.png`;
          link.click();
          URL.revokeObjectURL(url);
        }, 'image/png');
      };
      
      const svgData = new XMLSerializer().serializeToString(svg);
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);
      img.src = url;
    }
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(profileUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="glass-dark p-6 rounded-xl border border-dark-700">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-lime-bright">QR Code</h3>
        <button
          onClick={handleCopyUrl}
          className="text-sm text-lime-400 hover:text-lime-300 flex items-center space-x-1"
        >
          <SafeIcon icon={copied ? FiCheck : FiCopy} className="text-sm" />
          <span>{copied ? 'Copied!' : 'Copy URL'}</span>
        </button>
      </div>

      <div className="flex flex-col items-center space-y-4">
        <div className="glass p-4 rounded-lg border border-dark-700 bg-white">
          <QRCodeSVG
            id="qr-code-svg"
            value={profileUrl}
            size={size}
            level="H"
            includeMargin={true}
          />
        </div>

        <p className="text-sm text-dark-300 text-center max-w-xs">
          Scan this QR code to view your profile
        </p>

        <div className="flex items-center space-x-3 w-full">
          <button
            onClick={() => handleDownload('png')}
            className="flex-1 glass-lime text-lime-400 px-4 py-2 rounded-lg font-medium hover:text-lime-300 transition-colors border border-lime-500/50 hover:border-lime-400/70 shadow-glow-lime-sm inline-flex items-center justify-center"
          >
            <SafeIcon icon={FiDownload} className="mr-2" />
            Download PNG
          </button>
          <button
            onClick={() => handleDownload('svg')}
            className="flex-1 glass text-white px-4 py-2 rounded-lg font-medium hover:text-lime-400 transition-colors border border-dark-700 hover:border-lime-500/50 inline-flex items-center justify-center"
          >
            <SafeIcon icon={FiDownload} className="mr-2" />
            Download SVG
          </button>
        </div>

        <div className="w-full">
          <p className="text-xs text-dark-400 mb-2">Profile URL:</p>
          <div className="glass p-2 rounded border border-dark-700">
            <p className="text-xs text-dark-300 font-mono break-all">{profileUrl}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator;

